import Defaults from "./defaults.js";

export default {
  "--m-f-": Defaults[0],
  "--m-bf-": Defaults[1],
  "--m-t-": Defaults[2],
};
